import React from "react";
import Grid from "@material-ui/core/Grid";
import classes from "./Substantive.module.scss";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const SubstantiveTab = ({
  handleChangeInputs,
  userValues,
  handleChangeInputsPhone,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid item xs={12} md={6} style={{ paddingBottom: "0px" }}>
          <div
            className={
              i18n.language === "fa"
                ? classes.outlinedInputRtl
                : classes.outlinedInputLtr
            }
          >
            <FormControl variant="outlined">
              <OutlinedInput
                id="outlined-adornment-weight"
                name="firstName"
                onChange={(event) => handleChangeInputs(event)}
                value={userValues.firstName}
                startAdornment={
                  i18n.language === "fa" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.name")}
                    </InputAdornment>
                  )
                }
                endAdornment={
                  i18n.language === "en" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.name")}
                    </InputAdornment>
                  )
                }
              />
            </FormControl>
          </div>
          <div
            className={
              i18n.language === "fa"
                ? classes.outlinedInputRtl
                : classes.outlinedInputLtr
            }
          >
            <FormControl variant="outlined">
              <OutlinedInput
                id="outlined-adornment-weight"
                name="nationalCode"
                onChange={(event) => handleChangeInputs(event)}
                value={userValues.nationalCode}
                startAdornment={
                  i18n.language === "fa" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.national_code")}
                    </InputAdornment>
                  )
                }
                endAdornment={
                  i18n.language === "en" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.national_code")}
                    </InputAdornment>
                  )
                }
              />
            </FormControl>
          </div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <InputMask
              // mask="99999999999"
              disabled={false}
              value={userValues.phone}
              // maskChar=" "
              onChange={(event) => handleChangeInputs(event)}
              formatChars={{ "9": "[0-9۰-۹]" }}
            >
              {() => (
                <div
                  className={classes.outlinedInput}
                  style={{ width: "83%", margin: 0 }}
                >
                  <FormControl variant="outlined">
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      name="phone"
                      onChange={(event) => handleChangeInputs(event)}
                      // error={!phoneValidations}
                      value={userValues.phone}
                      startAdornment={
                        <InputAdornment
                          position="start"
                          disablePointerEvents={true}
                        >
                          {t("profile.tel")}
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
              )}
            </InputMask>
            <div
              className={classes.outlinedInputRtl}
              style={{ width: "15%", height: "100%", margin: 0 }}
            >
              <FormControl fullWidth style={{ height: "100%" }}>
                <Select
                  style={{
                    height: "100%",
                    padding: "11px 0",
                    border: "1px solid #0000003B",
                    borderRadius: "1rem",
                  }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={countryTelCode}
                  label="Age"
                  onChange={handleChangeCountryTelCode}
                >
                  <MenuItem value={"+98"}>{toFarsiNumber(+98)}+</MenuItem>
                  <MenuItem value={"+964"}>{toFarsiNumber(+964)}+</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div> */}
          <PhoneInput
            containerStyle={{
              direction: "ltr",
              borderRadius: "1em",
            }}
            inputStyle={{
              direction: "ltr",
              padding: "26px 0 26px 48px",
              width: "100%",
              borderRadius: "1em",
              backgroundColor: "#e7ecf4",
            }}
            dropdownStyle={{ textAlign: "left" }}
            buttonStyle={{
              borderRadius: "1em 0 0 1em",
              backgroundColor: "#e7ecf4",
            }}
            country={"ir"}
            placeholder={t("profile.tel")}
            className={classes.flagRoot}
            enableSearch={true}
            value={userValues.phone}
            onChange={(phone) =>
              handleChangeInputsPhone({
                target: { type: "select", value: phone, name: "phone" },
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={6} style={{ paddingBottom: "0px" }}>
          <div
            className={
              i18n.language === "fa"
                ? classes.outlinedInputRtl
                : classes.outlinedInputLtr
            }
          >
            <FormControl variant="outlined">
              <OutlinedInput
                id="outlined-adornment-weight"
                name="lastName"
                onChange={(event) => handleChangeInputs(event)}
                value={userValues.lastName}
                startAdornment={
                  i18n.language === "fa" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.last_name")}
                    </InputAdornment>
                  )
                }
                endAdornment={
                  i18n.language === "en" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.last_name")}
                    </InputAdornment>
                  )
                }
              />
            </FormControl>
          </div>
          <div
            className={
              i18n.language === "fa"
                ? classes.outlinedInputRtl
                : classes.outlinedInputLtr
            }
          >
            <FormControl variant="outlined">
              <OutlinedInput
                id="outlined-adornment-weight"
                name="substantiveEconomicCode"
                onChange={(event) => handleChangeInputs(event)}
                value={userValues.substantiveEconomicCode}
                inputProps={{
                  lang: "en-US",
                }}
                startAdornment={
                  i18n.language === "fa" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.economic_code")}
                    </InputAdornment>
                  )
                }
                endAdornment={
                  i18n.language === "en" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.economic_code")}
                    </InputAdornment>
                  )
                }
              />
            </FormControl>
          </div>
          <div
            className={
              i18n.language === "fa"
                ? classes.outlinedInputRtl
                : classes.outlinedInputLtr
            }
          >
            <FormControl variant="outlined">
              <OutlinedInput
                id="outlined-adornment-weight"
                name="postalCode"
                onChange={(event) => handleChangeInputs(event)}
                value={userValues.postalCode}
                startAdornment={
                  i18n.language === "fa" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.postal_code")}
                    </InputAdornment>
                  )
                }
                endAdornment={
                  i18n.language === "en" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.postal_code")}
                    </InputAdornment>
                  )
                }
              />
            </FormControl>
          </div>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: "0px" }}>
          <div
            className={
              i18n.language === "fa"
                ? classes.outlinedInputRtl
                : classes.outlinedInputLtr
            }
          >
            <FormControl variant="outlined">
              <OutlinedInput
                id="outlined-adornment-weight"
                name="address"
                multiline
                minRows={4}
                onChange={(event) => handleChangeInputs(event)}
                value={userValues.address}
                startAdornment={
                  i18n.language === "fa" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.address")}
                    </InputAdornment>
                  )
                }
                endAdornment={
                  i18n.language === "en" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("profile.address")}
                    </InputAdornment>
                  )
                }
              />
            </FormControl>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default SubstantiveTab;
